import { render } from "./base-input.vue?vue&type=template&id=811251b8&scoped=true&ts=true"
import script from "./base-input.vue?vue&type=script&lang=ts"
export * from "./base-input.vue?vue&type=script&lang=ts"

import "./base-input.vue?vue&type=style&index=0&id=811251b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-811251b8"]])

export default __exports__